module.exports = __webpack_public_path__ + "assets/img/saules-energijos-generavimas-ant-stogo.87aeb659.jpg";